import { NOT_YET_LOADED, hasData } from 'scenes/common/helpers/apiData';
import { ApiData, PaymentFrequency } from 'scenes/common/types';
import {
  MotorFlowType,
  MotorStepType,
  MotorFunnelState,
  MotorQuoteDetails,
} from 'scenes/motor/types';
import { defaultPaymentDetails } from 'scenes/common/flows/paymentDetails/defaults';
import {
  toQuoteDetails,
  toSelectedExtras,
  toReviewDetails,
} from 'scenes/motor/api/quote/marshaller';

import { defaultCoverOptions } from './coverOptions';
import { defaultDriver } from './addDriver';
import { defaultPolicyHolder } from './addPolicyHolder';
import { defaultPolicyDetails } from './policyDetails';
import { defaultMotorQuoteDetails } from './quoteDetails/defaults';
import { defaultReviewDetails } from './reviewDetails';

const state: MotorFunnelState = {
  flow: MotorFlowType.QuoteDetails,
  step: MotorStepType.PolicyStartDate,
  [MotorFlowType.QuoteDetails]: defaultMotorQuoteDetails,
  [MotorFlowType.AddDriver]: { ...defaultDriver, index: 0 },
  [MotorFlowType.CoverOptions]: defaultCoverOptions,
  [MotorFlowType.PolicyDetails]: defaultPolicyDetails,
  [MotorFlowType.AddPolicyHolder]: { ...defaultPolicyHolder, index: 0 },
  [MotorFlowType.PaymentDetails]: defaultPaymentDetails,
  [MotorFlowType.ReviewDetails]: defaultReviewDetails,
  [MotorFlowType.ReviewDriver]: { ...defaultDriver, index: 0 },
  apiResponses: {
    foundVehicle: NOT_YET_LOADED,
    quoteDetails: NOT_YET_LOADED,
    campaign: NOT_YET_LOADED,
    config: NOT_YET_LOADED,
  },
};

export const initialMotorFunnelState: (
  data?: ApiData<MotorQuoteDetails>
) => MotorFunnelState = (data?: ApiData<MotorQuoteDetails>) => {
  if (data && hasData(data)) {
    return {
      ...state,
      apiResponses: {
        ...state.apiResponses,
        quoteDetails: data,
      },
      step: MotorStepType.ReviewPolicyStartDate,
      flow: MotorFlowType.ReviewDetails,
      quoteDetails: toQuoteDetails(data),
      coverOptions: {
        preselectedPaymentFrequency: PaymentFrequency.Annually,
        selectedExtras: toSelectedExtras(data),
      },
      reviewDetails: toReviewDetails(data),
    };
  }
  return state;
};
